export const MARKET_MONITOR_ROUTE = '/market-intelligence/monitors/:workspaceId/:monitorId';
export type MarketMonitorTarget = { workspaceId: string; monitorId: string };
const uuid = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

export function parseMarketMonitorTarget(params: Partial<MarketMonitorTarget>): MarketMonitorTarget | null {
    const { workspaceId, monitorId } = params;
    return workspaceId && monitorId && uuid.test(workspaceId) && uuid.test(monitorId)
        ? { workspaceId: workspaceId.toLowerCase(), monitorId: monitorId.toLowerCase() } : null;
}
export function buildMarketMonitorPath(target: MarketMonitorTarget): string {
    const parsed = parseMarketMonitorTarget(target);
    if (!parsed) throw new Error('Invalid monitor target');
    return `/market-intelligence/monitors/${parsed.workspaceId}/${parsed.monitorId}`;
}
export function buildMarketMonitorSignInPath(target: MarketMonitorTarget): string {
    return `/auth?${new URLSearchParams({ redirect: `/admin${buildMarketMonitorPath(target)}` })}`;
}

type Access = { signedIn: boolean; profileLoading: boolean; workspaceLoading: boolean; workspaceError: boolean;
    workspaces: { id: string; name: string }[]; currentWorkspaceId: string | null };
export function resolveMonitorLinkState(target: MarketMonitorTarget | null, access: Access):
    { kind: 'invalid' | 'loading' | 'sign-in' | 'workspace-error' | 'unavailable' } |
    { kind: 'switch' | 'ready'; workspace: { id: string; name: string } } {
    if (!target) return { kind: 'invalid' };
    if (access.profileLoading) return { kind: 'loading' };
    if (!access.signedIn) return { kind: 'sign-in' };
    if (access.workspaceLoading) return { kind: 'loading' };
    if (access.workspaceError) return { kind: 'workspace-error' };
    const workspace = access.workspaces.find(item => item.id === target.workspaceId);
    if (!workspace) return { kind: 'unavailable' };
    return { kind: access.currentWorkspaceId === workspace.id ? 'ready' : 'switch', workspace };
}
